import { JobListResponse } from '@doda/api-client/aspida/@types';
import { createSlice } from '@reduxjs/toolkit';

/**
 * 初期表示求人一覧
 * @param requirements 募集・採用情報
 * @param income 年収
 * @param workplaceEnvironment 会社・職場
 * @param holidayAndWayOfWorking 休日・働き方
 * @param employeeAverageAge 社員の平均年齢
 * @param employmentStatus 雇用形態
 * @param welfareBenefits 福利厚生
 * @param positionsAndLanguageSkills 仕事内容・語学
 * @param establish 設立年数
 * @param initialDisplayFlag 初期表示判定フラグ
 */
export interface JobTrendRecommendListState {
  requirements: JobListResponse | null;
  income: JobListResponse | null;
  workplaceEnvironment: JobListResponse | null;
  holidayAndWayOfWorking: JobListResponse | null;
  employeeAverageAge: JobListResponse | null;
  employmentStatus: JobListResponse | null;
  welfareBenefits: JobListResponse | null;
  positionsAndLanguageSkills: JobListResponse | null;
  establish: JobListResponse | null;
}

// 初期状態
export const jobTrendRecommendListInitialState: JobTrendRecommendListState = {
  requirements: null,
  income: null,
  workplaceEnvironment: null,
  holidayAndWayOfWorking: null,
  employeeAverageAge: null,
  employmentStatus: null,
  welfareBenefits: null,
  positionsAndLanguageSkills: null,
  establish: null,
};

/**
 * State型
 * @param jobTrendRecommendList カテゴリごとの初期表示求人一覧
 */
export interface JobTrendRecommendListSliceState {
  jobTrendRecommendList: ReturnType<typeof jobTrendRecommendListReducer>;
}

const jobTrendRecommendListSlice = createSlice({
  name: 'jobTrendRecommendList',
  initialState: jobTrendRecommendListInitialState,
  reducers: {
    setRequirementsList: (state, action) => {
      state.requirements = action.payload;
    },
    setIncomeList: (state, action) => {
      state.income = action.payload;
    },
    setWorkplaceEnvironmentList: (state, action) => {
      state.workplaceEnvironment = action.payload;
    },
    setHolidayAndWayOfWorkingList: (state, action) => {
      state.holidayAndWayOfWorking = action.payload;
    },
    setEmployeeAverageAgeList: (state, action) => {
      state.employeeAverageAge = action.payload;
    },
    setEmploymentStatusList: (state, action) => {
      state.employmentStatus = action.payload;
    },
    setWelfareBenefitsList: (state, action) => {
      state.welfareBenefits = action.payload;
    },
    setPositionsAndLanguageSkillsList: (state, action) => {
      state.positionsAndLanguageSkills = action.payload;
    },
    setEstablishList: (state, action) => {
      state.establish = action.payload;
    },
  },
});

// Create Action
export const {
  setRequirementsList,
  setIncomeList,
  setWorkplaceEnvironmentList,
  setHolidayAndWayOfWorkingList,
  setEmployeeAverageAgeList,
  setEmploymentStatusList,
  setWelfareBenefitsList,
  setPositionsAndLanguageSkillsList,
  setEstablishList,
} = jobTrendRecommendListSlice.actions;

// reducer
export const jobTrendRecommendListReducer = jobTrendRecommendListSlice.reducer;

interface State {
  jobTrendRecommendList: JobTrendRecommendListState;
}

/**
 * selector
 * @param state
 * @returns 初期表示求人一覧
 */
export const jobTrendRecommendListSelector = <S extends State>(state: S) =>
  state.jobTrendRecommendList;
